/**
 * Product Meta Specs V3 - Toggle Functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  const specsContainer = document.querySelector('.product-meta-specs');

  if (!specsContainer) return;
  
  // const toggleButton = specsContainer.querySelector('.product-meta-specs__toggle');
  // const content = specsContainer.querySelector('.product-meta-specs__content');
  
  // // if (!toggleButton || !content) return;
  
  // // Initialize state - collapsed by default on mobile, expanded on desktop
  // const isMobile = window.innerWidth <= 768;
  // let isExpanded = !isMobile;
  
  // // Set initial state
  // updateToggleState();
  
  // // Add click event listener
  // toggleButton.addEventListener('click', function() {
  //   isExpanded = !isExpanded;
  //   updateToggleState();
  // });
  
  // // Handle window resize
  // window.addEventListener('resize', function() {
  //   const nowMobile = window.innerWidth <= 768;
  //   if (nowMobile !== isMobile) {
  //     // Screen size changed, update default state
  //     isExpanded = !nowMobile;
  //     updateToggleState();
  //   }
  // });
  
  // function updateToggleState() {
  //   if (isExpanded) {
  //     content.classList.remove('collapsed');
  //     toggleButton.classList.add('expanded');
  //     toggleButton.setAttribute('aria-expanded', 'true');
  //   } else {
  //     content.classList.add('collapsed');
  //     toggleButton.classList.remove('expanded');
  //     toggleButton.setAttribute('aria-expanded', 'false');
  //   }
  // }
  
  // // Handle keyboard navigation
  // toggleButton.addEventListener('keydown', function(e) {
  //   if (e.key === 'Enter' || e.key === ' ') {
  //     e.preventDefault();
  //     toggleButton.click();
  //   }
  // });
  
  // Initialize tooltip functionality
  initializeTooltips();
});

/**
 * Initialize tooltip functionality for random length indicators
 */
function initializeTooltips() {
  const tooltips = document.querySelectorAll('.product-meta-specs .tooltip');

  tooltips.forEach(tooltip => {
    const trigger = tooltip.querySelector('.tooltip__trigger');
    const content = tooltip.querySelector('.tooltip__content');
    
    if (!trigger || !content) return;
    
    // Mouse events
    tooltip.addEventListener('mouseenter', () => showTooltip(tooltip));
    tooltip.addEventListener('mouseleave', () => hideTooltip(tooltip));
    
    // Focus events for accessibility
    trigger.addEventListener('focus', () => showTooltip(tooltip));
    trigger.addEventListener('blur', () => hideTooltip(tooltip));
    
    // Touch events for mobile
    trigger.addEventListener('touchstart', (e) => {
      e.preventDefault();
      toggleTooltip(tooltip);
    });
    
    // Keyboard events
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleTooltip(tooltip);
      } else if (e.key === 'Escape') {
        hideTooltip(tooltip);
      }
    });
  });
  
  // Close tooltips when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.tooltip')) {
      hideAllTooltips();
    }
  });
}

function showTooltip(tooltip) {
  hideAllTooltips(); // Hide other tooltips first
  tooltip.classList.add('is-active');
  const content = tooltip.querySelector('.tooltip__content');
  if (content) {
    content.setAttribute('aria-hidden', 'false');
  }
}

function hideTooltip(tooltip) {
  tooltip.classList.remove('is-active');
  const content = tooltip.querySelector('.tooltip__content');
  if (content) {
    content.setAttribute('aria-hidden', 'true');
  }
}

function toggleTooltip(tooltip) {
  if (tooltip.classList.contains('is-active')) {
    hideTooltip(tooltip);
  } else {
    showTooltip(tooltip);
  }
}

function hideAllTooltips() {
  const activeTooltips = document.querySelectorAll('.tooltip.is-active');
  activeTooltips.forEach(tooltip => hideTooltip(tooltip));
}
